// Círculos geodésicos para MapLibre: anillos lng/lat reales, que escalan con
// el zoom porque no son píxeles. Los usan el radio de «Recursos cercanos»
// (MapV2.vue) y el selector de radio de la búsqueda inteligente.

const EARTH_RADIUS_M = 6371000

// Anillo cerrado (el último vértice repite el primero) alrededor de `center`
// [lng, lat], con `radiusMeters` de radio.
export function createGeoCircle(center, radiusMeters, steps) {
  const n = steps || 64
  const coords = []
  const lat = (center[1] * Math.PI) / 180
  const lng = (center[0] * Math.PI) / 180
  const d = radiusMeters / EARTH_RADIUS_M
  for (let i = 0; i <= n; i += 1) {
    const bearing = (i / n) * 2 * Math.PI
    const latNew = Math.asin(Math.sin(lat) * Math.cos(d)
      + Math.cos(lat) * Math.sin(d) * Math.cos(bearing))
    const lngNew = lng + Math.atan2(
      Math.sin(bearing) * Math.sin(d) * Math.cos(lat),
      Math.cos(d) - Math.sin(lat) * Math.sin(latNew),
    )
    coords.push([(lngNew * 180) / Math.PI, (latNew * 180) / Math.PI])
  }
  return coords
}

// Caja [[oeste, sur], [este, norte]] que encierra el círculo, en el formato
// que acepta `map.fitBounds`.
export function geoCircleBounds(center, radiusMeters) {
  const ring = createGeoCircle(center, radiusMeters)
  const lngs = ring.map((p) => p[0])
  const lats = ring.map((p) => p[1])
  return [
    [Math.min(...lngs), Math.min(...lats)],
    [Math.max(...lngs), Math.max(...lats)],
  ]
}
